
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoganpatipule() {



  const cardData =
  {
    keyword: 'Pune to Ganpatipule Taxi Service',
    heading: 'AB Ghule Cabs: Pune to Ganpatipule Taxi Service',
    headingDescription: 'Planning a trip to the serene Ganpatipule? Look no further than AB Ghule Cabs for your Pune to Ganpatipule taxi needs. We offer reliable, comfortable, and affordable cab services to ensure your journey is smooth and enjoyable. Whether you are heading for a spiritual getaway or a leisurely trip, our professional drivers and well-maintained vehicles make your journey to Ganpatipule a pleasant experience. The approximate distance from Pune to Ganpatipule is around 330 km.',

    top: 'Top Places to Visit in Ganpatipule with AB Ghule Cabs',

    "topPlaces": [
  {
    title: "Ganpatipule Temple",
    description: "The Ganpatipule Temple is the heart of the town, dedicated to Lord Ganesha. Situated on a hilltop, it offers a divine atmosphere and stunning views of the surrounding area. A must-visit for devotees and tourists alike."
  },
  {
    title: "Ganpatipule Beach",
    description: "This pristine, golden-sand beach is perfect for a relaxing day by the sea. Known for its peaceful ambiance, it’s an ideal place for a beach walk, picnic, or simply unwinding with family and friends."
  },
  {
    title: "Jaigad Fort",
    description: "Located around 25 km from Ganpatipule, Jaigad Fort offers a glimpse of history along with panoramic views of the Arabian Sea. It’s an ideal destination for history enthusiasts and nature lovers."
  },
  {
    title: "Malgund Beach",
    description: "A lesser-known, tranquil beach near Ganpatipule, Malgund Beach is perfect for those looking for a peaceful retreat. Enjoy the quiet beauty of the sea and sand away from the crowds."
  },
  {
    title: "Ratnagiri",
    description: "A nearby town, Ratnagiri is rich in historical sites and beautiful landscapes. Visit the Ratnadurg Fort, and enjoy the stunning views over the Arabian Sea, making it a perfect day trip from Ganpatipule."
  },
  {
    title: "Shree Swayambhu Ganapati Temple",
    description: "This temple is famous for its naturally formed idol of Lord Ganesha. It’s a sacred and important site for devotees traveling to Ganpatipule."
  },
  {
    title: "Aare Ware Beach",
    description: "Located a short distance from Ganpatipule, Aare Ware Beach offers peaceful surroundings and is perfect for a calm and relaxing experience."
  },
  {
    title: "Bhatye Beach",
    description: "Another quiet beach in the vicinity of Ganpatipule, Bhatye Beach is great for those who prefer a more private, serene experience by the sea."
  },
  {
    title: "Guhagar Beach",
    description: "Guhagar Beach, known for its clean surroundings and tranquil atmosphere, is a beautiful escape for those looking for a quiet beach getaway."
  },
  {
    title: "Ganga Kund",
    description: "A historic spot near the Ganpatipule Temple, Ganga Kund is a holy water tank that adds to the spiritual ambiance of the area. It's a place to connect spiritually while enjoying the scenic beauty."
  }
],


   services: [
    {
      "name": "Pune to Ganpatipule Taxi Fare",
      description: "Looking for affordable and reliable taxi services from Pune to Ganpatipule? At AB Ghule Cabs, we offer competitive taxi fares with no hidden charges. Enjoy a comfortable ride at the best price for your journey."
    },
    {
      "name": "Pune to Ganpatipule Cab Charges",
      description: "AB Ghule Cabs offers clear and reasonable cab charges for your trip from Pune to Ganpatipule. Our pricing is transparent, ensuring that you know exactly what you're paying for, without any surprises."
    },
    {
      "name": "Pune to Ganpatipule Taxi Booking",
      description: "Book your taxi from Pune to Ganpatipule online with AB Ghule Cabs. We offer quick and easy booking options, whether you're looking for a one-way trip or round-trip service. Book now for a seamless experience."
    },
    {
      "name": "Pune to Ganpatipule Car Rental",
      description: "Need a car rental for your trip to Ganpatipule? AB Ghule Cabs provides reliable car rental services, including luxury cars, sedans, and SUVs, for a comfortable ride to your destination."
    },
    {
      "name": "Pune to Ganpatipule Chauffeur-Driven Cabs",
      description: "Travel with ease and comfort by booking a chauffeur-driven cab for your journey from Pune to Ganpatipule. Our experienced drivers ensure a smooth ride, letting you sit back and enjoy the scenery."
    },
    {
      "name": "Pune to Ganpatipule Taxi Rates",
      description: "Our taxi rates for the Pune to Ganpatipule route are designed to offer the best value for money. With no hidden charges, you'll know exactly what you're paying for, whether you're booking a one-way or round-trip journey."
    },
    {
      "name": "Pune to Ganpatipule Cab Pricing",
      description: "Check out our affordable cab pricing for your trip from Pune to Ganpatipule. Whether you're traveling alone or with family, we offer a range of options to fit your needs and budget."
    },
    {
      "name": "Pune to Ganpatipule Taxi Fare Calculator",
      description: "Use our online taxi fare calculator to estimate the cost of your journey from Pune to Ganpatipule. AB Ghule Cabs offers transparent pricing with no surprises, making it easier for you to plan your trip."
    },
    {
      "name": "Pune to Ganpatipule Private Car Hire",
      description: "Book a private car for your journey from Pune to Ganpatipule. With AB Ghule Cabs, you get the comfort of traveling in a vehicle of your choice with complete privacy. Whether it's a business trip or a family vacation, we have the perfect car rental solution for you."
    },
    {
      "name": "Pune to Ganpatipule Cab Cost",
      description: "Get the best value for your trip from Pune to Ganpatipule with AB Ghule Cabs. Our cab cost includes all expenses, with no hidden charges. Book your ride today and travel with ease."
    },
    {
      "name": "Pune to Ganpatipule Taxi Service Charges",
      description: "Check out our affordable taxi service charges for your journey to Ganpatipule. AB Ghule Cabs offers the best rates for both one-way and round-trip services, ensuring that your trip is budget-friendly and comfortable."
    },
    {
      "name": "Pune to Ganpatipule Taxi",
      description: "Book your taxi from Pune to Ganpatipule with AB Ghule Cabs for a smooth and hassle-free journey. Whether you're traveling solo or with a group, we offer a range of vehicle options to suit your needs."
    },
    {
      "name": "Cab from Pune to Ganpatipule",
      description: "Need a reliable cab for your trip from Pune to Ganpatipule? AB Ghule Cabs provides a variety of vehicles, including sedans, SUVs, and luxury cars, to ensure that your trip is comfortable and convenient."
    },
    {
      "name": "Pune to Ganpatipule Cab Booking",
      description: "Booking a cab from Pune to Ganpatipule is easy with AB Ghule Cabs. Choose from a wide range of vehicles and book your ride online for a smooth journey."
    },
    {
      "name": "Pune to Ganpatipule Cab Service",
      description: "Enjoy a hassle-free ride with AB Ghule Cabs, offering top-quality cab services for your trip from Pune to Ganpatipule. Our reliable service ensures that you travel with comfort and peace of mind."
    },
    {
      "name": "Pune to Ganpatipule Innova Crysta",
      description: "Travel in style and comfort with an Innova Crysta for your trip to Ganpatipule. AB Ghule Cabs offers Innova Crysta rentals for a smooth and luxurious journey."
    },
    {
      "name": "Pune to Ganpatipule Innova Cab",
      description: "Book an Innova cab for your journey from Pune to Ganpatipule. With AB Ghule Cabs, you can enjoy a comfortable and spacious ride, perfect for families and groups."
    },
    {
      "name": "Pune to Ganpatipule Tempo Traveller",
      description: "For larger groups, AB Ghule Cabs offers Tempo Traveller services for your trip from Pune to Ganpatipule. With ample seating and space, it's the perfect choice for family trips, corporate outings, and more."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent in Pune",
      description: "If you're traveling with a large group, rent a 17-seater Tempo Traveller from AB Ghule Cabs. It's ideal for trips to Ganpatipule, providing comfort and ample space for everyone."
    },
    {
      "name": "Tempo Traveller on Rent in Pune",
      description: "AB Ghule Cabs offers Tempo Traveller rentals for both local and outstation trips, including Pune to Ganpatipule. Choose from a range of vehicle options to suit your group's size and comfort needs."
    },
    {
      "name": "Pune to Ganpatipule Beach Cab Service",
      description: "Planning to visit the beaches of Ganpatipule? AB Ghule Cabs offers specialized beach cab services for a comfortable and scenic ride to the coastline."
    },
    {
      "name": "Pune to Ganpatipule Taxi Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Ganpatipule Taxi. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Ganpatipule Taxi Fare", "- Pune to Ganpatipule Cab Charges"],
    ["Pune to Ganpatipule Taxi Booking", "- Pune to Ganpatipule Car Rental"],
    ["Pune to Ganpatipule Chauffeur-Driven Cabs", "- Pune to Ganpatipule Taxi Rates"],
    ["Pune to Ganpatipule Cab Pricing", "- Pune to Ganpatipule Taxi Fare Calculator"],
    ["Pune to Ganpatipule Private Car Hire", "- Pune to Ganpatipule Cab Cost"],
    ["Pune to Ganpatipule Taxi Service Charges", "- Pune to Ganpatipule Taxi"],
    ["Cab from Pune to Ganpatipule", "- Pune to Ganpatipule Cab Booking"],
    ["Pune to Ganpatipule Cab Service", "- Pune to Ganpatipule Innova Crysta"],
    ["Pune to Ganpatipule Innova Cab", "- Pune to Ganpatipule Tempo Traveller"],
    ["17 Seater Tempo Traveller on Rent in Pune", "- Tempo Traveller on Rent in Pune"],
    ["Pune to Ganpatipule Beach Cab Service", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Comfortable Service",
      WhyChoosedescription: "AB Ghule Cabs offers a comfortable and reliable taxi service for your journey from Pune to Ganpatipule. Whether you're traveling for leisure or pilgrimage, we ensure that your trip is smooth and hassle-free."
    },
    {
      WhyChooseheading: "Competitive and Transparent Pricing",
      WhyChoosedescription: "We offer affordable and transparent pricing, ensuring you get the best value for your money. There are no hidden charges, and our prices are designed to suit all budgets, making it easy for you to plan your trip."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our fleet of vehicles is well-maintained, clean, and regularly serviced to ensure a comfortable ride. Whether you prefer a sedan, SUV, or a luxury car, we have a range of options to suit your needs."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our experienced drivers are knowledgeable about the best routes and roads to take, ensuring a safe and timely journey. They are courteous, well-trained, and always prioritize your comfort and safety."
    },
    {
      WhyChooseheading: "On-Time Pick-Up and Drop-Off",
      WhyChoosedescription: "We understand the importance of punctuality. Our drivers are always on time for your pick-up from Pune, ensuring that you reach Ganpatipule without any delays, so you can relax and enjoy your trip."
    },
    {
      WhyChooseheading: "Easy and Convenient Booking Process",
      WhyChoosedescription: "Booking a taxi with AB Ghule Cabs is quick and easy. You can book your ride online through our website or mobile app, or you can call our customer service for assistance."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We are available 24/7, ensuring that we are always ready to serve you at any time of the day or night. Whether you need a ride early in the morning or late in the evening, we are here to cater to your needs."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi from Pune to Ganpatipule?',
      answer: 'You can book your taxi through our website, mobile app, or by calling our customer service team for instant assistance.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a one-way trip from Pune to Ganpatipule?',
      answer: 'The one-way fare for a sedan typically ranges from ₹5,500 to ₹6,500. The fare will vary depending on the vehicle and other factors.',
    },
    {
      id: 'FAQ3',
      question: 'Are the fares inclusive of taxes and tolls?',
      answer: 'Yes, the fares include taxes, tolls, and all applicable charges. There are no hidden fees.',
    },
    {
      id: 'FAQ4',
      question: 'How long will the journey from Pune to Ganpatipule take?',
      answer: 'The journey typically takes 6 to 7 hours, depending on traffic and road conditions.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round trip from Pune to Ganpatipule?',
      answer: 'Yes, we offer round-trip bookings at competitive rates. You can get in touch with our team to know more.',
    },
    {
      id: 'FAQ6',
      question: 'Do you offer a pick-up from any location in Pune?',
      answer: 'Yes, we provide pick-up services from any location in Pune, including homes, hotels, or business addresses.',
    },
    {
      id: 'FAQ7',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our vehicles are fully air-conditioned for your comfort during long journeys.',
    },
    {
      id: 'FAQ8',
      question: 'Can I choose the vehicle for my trip?',
      answer: 'Yes, you can select from a range of vehicles, including sedans, SUVs, and luxury cars, depending on your preferences.',
    },
    {
      id: 'FAQ9',
      question: 'How do I pay for the taxi service?',
      answer: 'You can pay via cash, credit/debit card, or through our mobile app for easy and secure payments.',
    },
    {
      id: 'FAQ10',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, and these will be communicated to you in advance.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Amit Shah',
      feedback: 'I traveled with AB Ghule Cabs from Pune to Ganpatipule for a family vacation, and the experience was excellent. The car was clean and comfortable, and the driver was very professional. The journey was smooth, and we reached Ganpatipule in a timely manner. Highly recommend this service!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Priya Patil',
      feedback: 'Booking a taxi from Pune to Ganpatipule was a breeze with AB Ghule Cabs. The vehicle was comfortable, and the driver was very friendly. We enjoyed the scenic journey and arrived safely and on time. Great service, will definitely use again.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Ganpatipule Taxi Fare | Affordable Cab & Car Rental Services</title>
  <meta name="description" content="Book a taxi from Pune to Ganpatipule with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Ganpatipule Taxi Fare, Pune to Ganpatipule Cab Charges, Pune to Ganpatipule Taxi Booking, Pune to Ganpatipule Car Rental, Pune to Ganpatipule Chauffeur-Driven Cabs, Pune to Ganpatipule Taxi Rates, Pune to Ganpatipule Cab Pricing, Pune to Ganpatipule Taxi Fare Calculator, Pune to Ganpatipule Private Car Hire, Pune to Ganpatipule Cab Cost, Pune to Ganpatipule Taxi Service Charges, Pune to Ganpatipule Taxi, Cab from Pune to Ganpatipule, Pune to Ganpatipule Cab Booking, Pune to Ganpatipule Cab Service, Pune to Ganpatipule Innova Crysta, Pune to Ganpatipule Innova Cab, Pune to Ganpatipule Tempo Traveller, 17 Seater Tempo Traveller on Rent in Pune, Tempo Traveller on Rent in Pune, Pune to Ganpatipule Beach Cab Service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Ganpatipule Taxi Fare | Affordable Cab & Car Rental Services" />
  <meta property="og:description" content="Book a taxi from Pune to Ganpatipule with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-ganpatipule-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-ganpatipule-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Ganpatipule Taxi",
        description: "Book a taxi from Pune to Ganpatipule with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-ganpatipule-taxi",
        "logo": "https://abghulecabs.com/images/pune-to-ganpatipule-taxi.jpg",
        "image": "https://abghulecabs.com/images/pune-to-ganpatipule-taxi.jpg",
        "priceRange": "₹3000 - ₹7000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-ganpatipule-taxi",
          "priceCurrency": "INR",
          "price": "3000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Deepak R"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "Great experience with AB Ghule Cabs! The ride was comfortable, and the driver was very polite and professional. Highly recommend their services for Pune to Ganpatipule trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya M"
            },
            "datePublished": "2024-10-12",
            "reviewBody": "We booked an Innova for our trip to Ganpatipule and had a pleasant journey. The vehicle was clean and well-maintained. Will definitely use their services again."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Ganpatipule Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "17.4348",
            "longitude": "73.3437"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-ganpatipule-taxi"
        },
        "keywords": "Pune to Ganpatipule Taxi Fare, Pune to Ganpatipule Cab Charges, Pune to Ganpatipule Taxi Booking, Pune to Ganpatipule Car Rental, Pune to Ganpatipule Chauffeur-Driven Cabs, Pune to Ganpatipule Taxi Rates, Pune to Ganpatipule Cab Pricing, Pune to Ganpatipule Taxi Fare Calculator, Pune to Ganpatipule Private Car Hire, Pune to Ganpatipule Cab Cost, Pune to Ganpatipule Taxi Service Charges, Pune to Ganpatipule Taxi, Cab from Pune to Ganpatipule, Pune to Ganpatipule Cab Booking, Pune to Ganpatipule Cab Service, Pune to Ganpatipule Innova Crysta, Pune to Ganpatipule Innova Cab, Pune to Ganpatipule Tempo Traveller, 17 Seater Tempo Traveller on Rent in Pune, Tempo Traveller on Rent in Pune, Pune to Ganpatipule Beach Cab Service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/50.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetoganpatipule;